// Season is derived from the calendar only. No env var override.
// Summer/fall: April through October. Winter: November through March.
export const getSeason = (date = new Date()) => {
  const month = date.getMonth(); // 0-indexed
  return month >= 3 && month <= 9 ? 'summer' : 'winter';
};

export const season = getSeason();
